module.exports = __webpack_public_path__ + "img/fi-rr-time-forward-sixty.a662b63a.svg";